import Fetch, { V1, V3, V4 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_POST_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

const fetchPost = (resourceUrl, payload, isForm = false, userPinToken = false) =>
  Fetch.post(resourceUrl, payload, isForm, userPinToken)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

const fetchGet = (resourceUrl, userPinToken = false) =>
  Fetch.get(resourceUrl, userPinToken)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

export const postForgetPin = (version = V4, payload = {}) => {
  const resourceUrl = `${version}users/me/pin/forget/`;
  return fetchPost(resourceUrl, payload, false, true);
};

export const postValidatePin = (payload) => {
  const resourceUrl = `${V4}users/me/pin/validate/`;
  return fetchPost(resourceUrl, payload, false, true);
};

export const postPinStatus = () => {
  const resourceUrl = `${V4}users/me/pin/status/`;
  return fetchPost(resourceUrl, {}, false, true);
};

export const getPinData = () => {
  const resourceUrl = `${V3}users/me/pin/get-pin-data/`;
  return fetchGet(resourceUrl, true);
};

export const getIdAvailibility = () => {
  const resourceUrl = `${V4}users/me/pin/id-availability`;
  return fetchGet(resourceUrl, true);
};
